import  html2pdf  from 'html2pdf.js'
import moment from 'moment'
import React, { memo, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useStyle } from './style'
import { resetData } from '../../hooks/printPdf/pdfData'
import { useLocation, useNavigate } from 'react-router-dom'
import _ from 'lodash'
import axios from 'axios'

const Invoices = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [gst , setGst] = useState([])
    const [gData , setGData] = useState([])
    const location = useLocation()
const data = useSelector(state=> state.getData)
const ref = useRef(null)
console.log(location.pathname === '/warehouse/sales-or-issue' ? "hai" : "bye")
const classes = useStyle()
console.log(data)
const currentDate = new Date().toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
  const totalCgstAmnt = data.getData!==null && data.getData.tableData.reduce((acc, value) => acc + Number(value.cgstAmnt), 0);
  const rowTotals = data.getData!==null && data.getData.tableData.map((value) => Number(value.cgstAmnt) + Number(value.cgstAmnt));
  const totalNetAmnt = data.getData!==null && data.getData.tableData.reduce((acc, rowTotal) => acc + rowTotal.totalAmt, 0);

  useEffect(()=>{
    if(data.getData!==null && data.getData.tableData.length > 0){   
        console.log(data.getData)
        const groupedData = _.groupBy(data.getData.tableData,'cgstPerc')

        const result = _.map(groupedData,(val,tax)=>({
            cgstPerc : parseFloat(tax),
            gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
        }))
        const groupedData1 = _.groupBy(data.getData.tableData, item=> `${item.pro_name}_${item.hsn}_${item.mrp}_${item.sale_rate}_${item.cgstPerc}_${item.pur_rate}`)
                const result2= _.map(groupedData1,(val,tax)=>({
                    cgstPerc : val[0].cgstPerc,
                    pro_name : val[0].pro_name,
                    sale_rate : val[0].sale_rate,
                    pur_rate: val[0].pur_rate,
                    cgstAmnt : _.sumBy(val, item=> parseFloat(item.cgstAmnt)),
                    hsn : val[0].hsn,
                    qty : _.sumBy(val, item=> parseFloat(item.qty)),
                    totalAmt: _.sumBy(val, item=> parseFloat(item.totalAmt)),
                    disc1: val[0].disc1,
                    gstAmt : _.sumBy(val, item=> parseFloat(item.cgstAmnt))
                }))
                console.log(result,'hi', data.getData.tableData[0])
                setGst(result)
                setGData(result2)

    }
    },[data])
console.log(data)
useEffect(()=>{
if(gst.length > 0){   
    const input = ref.current;
    const pdfOptions = {
      margin: 10,
      filename: `billNo_${data.getData.companyInfo.docno}_${moment().format("YYYY-MM-DD")}`, // Include the date in the filename
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      pagebreak: { mode: 'avoid-all' },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
    };
    
html2pdf().set(pdfOptions).from(input).save()

  setTimeout(()=>{
    // window.location.reload();
    dispatch(resetData())
    navigate(-1)
  },3000)
}
},[gst])
// console.log(data.getData.companyInfo.mode,"gDatagData");

  return (
    <div ref={ref} className='bg-white w-full' >
   {data.getData !== null && 
    <Grid sx={{border:'2px solid black'}}>
    <Typography fontWeight={600} variant='h5' textAlign='center' sx={{backgroundColor:'rgb(203 213 225)', borderBottom:'1px solid', width:'100%', paddingBlock:1}}>{data.getData.title}</Typography>
     <Grid className='pl-3 mb-3'>
     <Typography className={classes.pdfTitle}>{data.getData.companyname}</Typography>
     {/* <Typography className={classes.pdfTitle}>{data.getData.companyInfo.company_fullname}</Typography> */}
         <Typography className={classes.pdfText}>{`${data.getData.companyInfo.company_add1} ${data.getData.companyInfo.company_add2}`}</Typography>
         <Typography className={classes.pdfText}>{data.getData.companyInfo.city_name} - {data.getData.companyInfo.company_pincode}</Typography>
         <Typography className={classes.pdfText}>{data.getData.companyInfo.state_name}</Typography>
         
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>GST </Typography>
             <Typography>- {data.getData.companyInfo.company_gstin}</Typography>
         </div>
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>Email : </Typography>
             <Typography> {data.getData.companyInfo.company_email}</Typography>
         </div>
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>Mobile : </Typography>
             <Typography> {data.getData.companyInfo.company_mobile}</Typography>
         </div>
         
     </Grid>
    <Divider sx={{border:"1px solid #000"}} />
    <Grid container sx={{marginBottom : 1}}>
     <Grid item xs={12} md={8} className='pl-3  '>
        
      

         <Typography className={classes.pdfTitle}>{data.getData.companyInfo.outlet_acname}</Typography>
     {/* <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_fullname}</Typography> */}
         <Typography className={classes.pdfText}>{`${data.getData.companyInfo.outlet_add1} ${data.getData.companyInfo.outlet_add2}`}</Typography>
         {/* <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_add2}</Typography> */}
         <Typography className={classes.pdfText}>{data.getData.companyInfo.city_name} - {data.getData.companyInfo.outlet_pincode}</Typography>
         <Typography className={classes.pdfText}>{data.getData.companyInfo.state_name}</Typography>
         {/* <Typography className={classes.pdfText}>{data.getData.companyInfo.outlet_pincode}</Typography> */}
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>GST </Typography>
             <Typography>- {data.getData.companyInfo.outlet_gstin}</Typography>
         </div>
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>Email </Typography>
             <Typography>- {data.getData.companyInfo.outlet_email}</Typography>
         </div>
         <div className={classes.pdfFlex}>
             <Typography className={classes.pdfText}>Mobile </Typography>
             <Typography>- {data.getData.companyInfo.outlet_mobile}</Typography>
         </div>
     </Grid>
     <Grid item xs={12} md={4}>
         <Table >
             <TableBody>
                 <TableRow className={classes.subRow}>
                     <TableCell className={classes.tblCell}>Invoice No</TableCell>
                     {/* <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.docno.replace("_", "/").replace("_", "-").replace("_", "/")}</TableCell> */}
                     <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.docno}</TableCell>
                 </TableRow>
                 <TableRow className={classes.subRow}>
                     <TableCell className={classes.tblCell}>Payment Mode</TableCell>
                     <TableCell sx={{fontWeight:600}}>{data.getData.companyInfo.mode || "-"}</TableCell>
                 </TableRow>   
                 <TableRow className={classes.subRow}>
                     <TableCell className={classes.tblCell}>Date</TableCell>
                     <TableCell sx={{fontWeight:600}}>{currentDate}</TableCell>
                 </TableRow>   
                 <TableRow className={classes.subRow}>
                     <TableCell className={classes.tblCell}>Total</TableCell>
                     <TableCell sx={{fontWeight:600}}>{data.getData.TotalData.totalAmount}</TableCell>
                 </TableRow>
             </TableBody>
         </Table>
     </Grid>
    </Grid>
    <TableContainer className={classes.tblRoot}>
     <Table>
         <TableHead className={classes.tblHead}>
             <TableRow >
                 <TableCell rowSpan={2} >Sl No</TableCell>
                 <TableCell rowSpan={2}>Description of Goods</TableCell>
                 {data.getData.tableData.some(val => val.hsn) && <TableCell rowSpan={2}>HSN Code</TableCell>}
                 <TableCell rowSpan={2}>Rate</TableCell>
                 <TableCell rowSpan={2}>Qty</TableCell>
                 <TableCell rowSpan={2}>Discount</TableCell>
                 {/* <TableCell rowSpan={2}>Taxable Value</TableCell> */}
               {data.getData.companyInfo.mode === "Transfer" ? "" : 
               <>
                <TableCell colSpan={2}>CGST</TableCell>
                 <TableCell colSpan={2}>SGST</TableCell>
                 </>
                 }
                 <TableCell rowSpan={2} >Amount</TableCell>
             </TableRow>
             {data.getData.companyInfo.mode === "Transfer" ? "" :
             <TableRow >
                 {/* <TableCell/> */}
                 <TableCell>%</TableCell>
                 <TableCell>Amt</TableCell>
                 <TableCell>%</TableCell>
                 <TableCell>Amt</TableCell>
             </TableRow>}
         </TableHead>
         <TableBody>
            {_.map(gData , (val,idx) => (
                <TableRow className={classes.tblRow} key={idx}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{val.pro_name}</TableCell>
                    {val.hsn && <TableCell>{val.hsn}</TableCell>}
                    {val.sale_rate && <TableCell>{val.sale_rate}</TableCell>} 
                    {/* {val.pur_rate && <TableCell>{val.pur_rate}</TableCell>}  */}
                    <TableCell>{val.qty}</TableCell> 
                    <TableCell>{val.disc1}</TableCell>
                    {/* {val.pur_rate && <TableCell>{parseFloat(val.pur_rate * val.qty).toFixed(2)}</TableCell>}                    
                    {val.sale_rate && <TableCell>{parseFloat(val.sale_rate * val.qty).toFixed(2)}</TableCell>}  */}
                    {/* <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
                    <TableCell> {parseFloat(val.cgstAmnt / 2).toFixed(2)}</TableCell>
                    <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
                    <TableCell> {parseFloat(val.cgstAmnt / 2).toFixed(2)}</TableCell>
                    <TableCell>{parseFloat(Number(val.totalAmt) + Number(val.cgstAmnt)).toFixed(2)  }</TableCell> */}

{data.getData.companyInfo.mode === "Transfer" ? "" :
    <>        <TableCell>{!isNaN(parseFloat(val.cgstPerc)) ? (parseFloat(val.cgstPerc) / 2).toFixed(2) : '0.00'}</TableCell>
<TableCell>{!isNaN(parseFloat(val.cgstAmnt)) ? (parseFloat(val.cgstAmnt) / 2).toFixed(2) : '0.00'}</TableCell>
<TableCell>{!isNaN(parseFloat(val.cgstPerc)) ? (parseFloat(val.cgstPerc) / 2).toFixed(2) : '0.00'}</TableCell>
<TableCell>{!isNaN(parseFloat(val.cgstAmnt)) ? (parseFloat(val.cgstAmnt) / 2).toFixed(2) : '0.00'}</TableCell> </>}
<TableCell>
  {!isNaN(Number(val.totalAmt)) && !isNaN(Number(val.cgstAmnt))
    ? (Number(val.totalAmt) + Number(val.cgstAmnt)).toFixed(2)
    : '0.00'}
</TableCell>

               
                </TableRow>
            ))}
         </TableBody>
     </Table>
    </TableContainer>
    <Grid className='flex justify-between p-2'>
     <TableContainer className={classes.tblRoot} sx={{maxWidth: 'fit-content'}}>
     {data.getData.companyInfo.mode === "Transfer" ? "" :
         <Table sx={{borderLeft:'1px solid'}}>
             <TableHead className={classes.tblHead}>
                 <TableRow>
                     <TableCell>Tax</TableCell>
                     <TableCell>CGST Amt</TableCell>
                     <TableCell>SGST Amt</TableCell>
                     <TableCell>Total</TableCell>
                 </TableRow>
             </TableHead>
             <TableBody>
                {_.map(gst , (value , idx) => (
                    <TableRow className={classes.tblRow} key={idx}>
                        <TableCell>{parseFloat(value.cgstPerc).toFixed(2)}</TableCell>
                        <TableCell>{parseFloat(value.gstAmt  / 2).toFixed(2) }</TableCell>
                        <TableCell>{parseFloat(value.gstAmt  / 2).toFixed(2) }</TableCell>
                        <TableCell>{parseFloat(value.gstAmt).toFixed(2)}</TableCell>
                    </TableRow>
                ))}
                 <TableRow className={classes.tblRow}>
                     <TableCell>Total</TableCell>
                     <TableCell >{parseFloat(totalCgstAmnt / 2).toFixed(2) }</TableCell>
                     <TableCell>{parseFloat(totalCgstAmnt / 2).toFixed(2)}</TableCell>
                     <TableCell>{parseFloat(totalCgstAmnt).toFixed(2)  }</TableCell>
                 </TableRow>
             </TableBody>
         </Table>
}
     </TableContainer>
     <Grid sx={{width:150, }}>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Sub Total  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.sub_total).toFixed(2)}</Typography>
         </div>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>GST  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.gst).toFixed(2)}</Typography>
         </div>
         {/* <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Cess  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.cess_amt).toFixed(2) }</Typography>
         </div> */}
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Round Off  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.roundOff).toFixed(2)}</Typography>
         </div>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Total  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
         </div>
         
     </Grid>
    </Grid>
    <Divider sx={{border:"1px solid #000"}} />
    <Grid className='flex justify-between'>
         <Grid className='flex justify-between w-full items-center px-2'>
             <Typography fontWeight={600} fontSize={16}>{data.getData.totalText} Rupees Only</Typography>
             <Typography>Total</Typography>
         </Grid>
         <Grid  sx={{width:190, borderLeft:'1px solid ', padding:3 }}>
             <Typography fontWeight={600} fontSize={16} textAlign='right'>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
         </Grid>
    </Grid> 
    <Divider sx={{border:"1px solid #000"}} />
    <Grid className='pl-3 pt-1 mb-2'>
     <Typography className={classes.pdfUnderLine}>Bank Details</Typography>
     <div className={classes.pdfFlex}>
         <Typography className={classes.pdfTextTable}>Account holders name :   </Typography>
         <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_acname}</Typography>
     </div>
     <div className={classes.pdfFlex}>
         <Typography className={classes.pdfTextTable}>Bank :   </Typography>
         <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_bankname}</Typography>
     </div>
     <div className={classes.pdfFlex}>
         <Typography className={classes.pdfTextTable}>Account no :   </Typography>
         <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_bankacno}</Typography>
     </div>
     <div className={classes.pdfFlex}>
         <Typography className={classes.pdfTextTable}>IFSC :   </Typography>
         <Typography className={classes.pdfTextTable}> {data.getData.companyInfo.outlet_ifsccode}</Typography>
     </div>
    </Grid>
    <Divider sx={{border:"1px solid #000"}} />
    <Grid className='flex justify-between px-3 mb-3' sx={{marginTop:2}}>
     <Typography  sx={{fontSize:16,fontWeight:600}}>Received in good condition</Typography>
     {/* <Typography>For <span  style={{fontSize:16,fontWeight:600}}>{data.getData.companyInfo.name}</span></Typography> */}
    </Grid>
    <Grid className='flex justify-between px-2 ' sx={{borderBottom:'1px solid',borderTop:'1px solid', marginTop:3}}>
      <Grid>
      <Typography sx={{ width:'100%'}} fontWeight={600}>Declaration :</Typography>
     <Typography maxWidth={'60%'} sx={{paddingBlock:1}}>
         We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct
         </Typography>
      </Grid>
         <Typography textAlign='left' width='100%' maxWidth='40%' sx={{borderLeft:'1px solid', paddingBlock:1, paddingLeft:1}}>Authorised Signatory</Typography>
    </Grid>
    <Grid >
     <Typography align='right' sx={{fontWeight:600, paddingBlock:1,paddingRight:3,paddingBlockEnd:2}}>This is computer generated Invoice</Typography>
    </Grid>
 </Grid>
   }
</div>
  )
}

export default memo(Invoices)